import { CALENDLY_CSS_HREF, CALENDLY_SCRIPT_SRC } from './Calendly.constants';

let calendlyAssetsPromise: Promise<void> | null = null;

const loadCalendlyCss = (): Promise<void> =>
  new Promise((resolve, reject) => {
    const existingCss = document.querySelector<HTMLLinkElement>(
      `link[href="${CALENDLY_CSS_HREF}"]`,
    );

    if (existingCss) {
      resolve();
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = CALENDLY_CSS_HREF;
    link.onload = () => resolve();
    link.onerror = () => reject(new Error('Failed to load Calendly CSS'));

    document.head.appendChild(link);
  });

const loadCalendlyScript = (): Promise<void> =>
  new Promise((resolve, reject) => {
    if (window.Calendly) {
      resolve();
      return;
    }

    const existingScript = document.querySelector<HTMLScriptElement>(
      `script[src="${CALENDLY_SCRIPT_SRC}"]`,
    );

    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(), { once: true });
      existingScript.addEventListener(
        'error',
        () => reject(new Error('Failed to load Calendly script')),
        { once: true },
      );
      return;
    }

    const script = document.createElement('script');
    script.src = CALENDLY_SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Calendly script'));

    document.body.appendChild(script);
  });

export const loadCalendlyAssets = async (): Promise<void> => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!calendlyAssetsPromise) {
    calendlyAssetsPromise = Promise.all([loadCalendlyCss(), loadCalendlyScript()])
      .then(() => undefined)
      .catch((error) => {
        calendlyAssetsPromise = null;
        throw error;
      });
  }

  return calendlyAssetsPromise;
};
